import React, { createContext, useState, useEffect } from 'react';
import { Api_Url } from './APIUrl';
import { useLocation } from 'react-router-dom';

export const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const [walletBalance, setWalletBalance] = useState(null);
  const [lastModified, setLastModified] = useState(null); // To track changes
  const location = useLocation(); // Track current route

  const fetchProfile = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`);
      if (lastModified) {
        myHeaders.append('If-Modified-Since', lastModified); // Add conditional header
      }

      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
      };

      const response = await fetch(`${Api_Url}api/profile`, requestOptions);

      if (response.status === 200) {
        const result = await response.json();
        if (result.success) {
          setProfile(result.data.user);
          setWalletBalance(result.data.user.wallet_balance);
          setLastModified(response.headers.get('Last-Modified')); // Update lastModified
        }
      } else if (response.status === 304) {
        console.log('No changes detected'); // No need to update
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  useEffect(() => {
    // Check if the current route is '/ludoking'
    if (location.pathname === '/ludoking') {
      fetchProfile();
    }
  }, [location.pathname]); // Re-run this effect whenever the route changes

  return (
    <ProfileContext.Provider value={{ profile, walletBalance, setWalletBalance, fetchProfile }}>
      {children}
    </ProfileContext.Provider>
  );
};
